"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = void 0;
const tslib_1 = require("tslib");
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const html_svg_1 = tslib_1.__importDefault(require("./static/img/icons/html.svg"));
const json_svg_1 = tslib_1.__importDefault(require("./static/img/icons/json.svg"));
const reactts_svg_1 = tslib_1.__importDefault(require("./static/img/icons/reactts.svg"));
const testts_svg_1 = tslib_1.__importDefault(require("./static/img/icons/testts.svg"));
const typescript_svg_1 = tslib_1.__importDefault(require("./static/img/icons/typescript.svg"));
const Monogram_1 = require("./Monogram");
const icons = {
    reactts: reactts_svg_1.default,
    testts: testts_svg_1.default,
    typescript: typescript_svg_1.default,
    html: html_svg_1.default,
    json: json_svg_1.default,
};
const getFileType = (path) => {
    if (path.endsWith('.test.ts')) {
        return 'testts';
    }
    if (path.endsWith('.tsx')) {
        return 'reactts';
    }
    if (path.endsWith('.html')) {
        return 'html';
    }
    if (path.endsWith('.json')) {
        return 'json';
    }
    return 'typescript';
};
exports.FileIcon = (_a) => {
    var { path } = _a, props = tslib_1.__rest(_a, ["path"]);
    if (path.endsWith('.one.ts')) {
        return React.createElement(Monogram_1.Monogram, Object.assign({}, props));
    }
    const type = getFileType(path);
    const source = icons[type];
    return React.createElement(react_core_1.Image, Object.assign({ src: source, alt: type }, props));
};

//# sourceMappingURL=FileIcon.js.map
